export default {
  state: {
    progress: false,
    confirm_modal: false,
    add_customer_modal: false,
    mark_as_sent_modal: false,
    add_equipment_modal: false,
    add_equipment_category_modal: false,
    send_quotation_modal: false,
    send_message_new_files_upload_modal: false,
    add_type_option_modal: false,
    forgot_password_modal: false,
    send_whats_quotation_modal: false,
    upload_file_modal: false,
    customers_modal: false,
    agents_modal: false,
    import_pdf_modal: false,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
  },
};
